import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// -----------------orderListApi-List-Api-------------------------
export const orderListApi = async (data) => {
  const endPoint = `/admin/order?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
// -----------------orderList-details-Api---------------------------
export const orderDetailsApi = async (id) => {
  const endPoint = `/admin/order/${id}`;
  return await axios.get(endPoint, setJwtToken());
};

// -----------------change-order-status--Api---------------------------
export const changeOrderStatusApi = async (data) => {
  const endPoint = `/admin/order`;
  return await axios.put(endPoint, data, setJwtToken());
};



export const updateAddressApi = async (data) => {
  const endPoint = `/admin/order/update/address`;
  return await axios.post(endPoint, data, setJwtToken());
};







 